import React from "react";
import { TFunction } from "i18next";

import ErrorToast from "@components/Common/ErrorTost";
import { CESAR_LOYALTY } from "@constants/index";

type Params = {
    selectedRows: FidelityRow[];
    oneShop: boolean;
    isFidelityArchived: boolean;
    dataArchive: string[];
    dataActive: string[];
    isModalOpened: boolean;
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setIsModalOpenedSupport: React.Dispatch<React.SetStateAction<boolean>>;
    setIsArchiveModalOpened: (v: boolean) => void;
    setIsFidelityClicked: (v: boolean) => void;
    activate: () => Promise<void>;
    t: TFunction;
};

export function useBulkArchiveClick(params: Params) {
    const {
        selectedRows,
        oneShop,
        isFidelityArchived,
        dataArchive,
        dataActive,
        isModalOpened,
        setIsModalOpened,
        setIsModalOpenedSupport,
        setIsArchiveModalOpened,
        setIsFidelityClicked,
        activate,
        t,
    } = params;

    const triggerArchiveFlow = React.useCallback(() => {
        const hasCesar = selectedRows.some(
            (row: FidelityRow) => row.fidelityChoiceIndex === CESAR_LOYALTY
        );
        if (hasCesar) {
            setIsModalOpenedSupport(true);
        } else {
            setIsArchiveModalOpened(true);
        }
    }, [selectedRows, setIsArchiveModalOpened, setIsModalOpenedSupport]);

    return React.useCallback(() => {
        setIsFidelityClicked(true);

        if (selectedRows.length === 1) {
            ErrorToast(
                t(
                    "Attention, it is a multiple action. Please select at least two items"
                )
            );
            return;
        }

        const hasNonCesar = selectedRows.some(
            (el: FidelityRow) => el.fidelityChoiceIndex !== CESAR_LOYALTY
        );
        const activeHasOnlySoftavera = dataActive.some(
            (el: string) => el !== t("Softavera")
        );
        const shouldBlockFranchiseUnarchive =
            selectedRows.length > 1 &&
            isFidelityArchived &&
            (oneShop ||
                (!oneShop && hasNonCesar && dataActive.length === 0) ||
                activeHasOnlySoftavera);

        if (shouldBlockFranchiseUnarchive) {
            ErrorToast(
                oneShop
                    ? t(
                          "Attention,a shop cannot have more than one fidelity settings"
                      )
                    : t(
                          "Attention, a franchise cannot have more than one setting fidelity"
                      )
            );
            return;
        }

        if (!isFidelityArchived) {
            triggerArchiveFlow();
            return;
        }

        const rowsAlreadyArchived = selectedRows.some((el: FidelityRow) =>
            dataArchive.includes(el.Id)
        );
        if (rowsAlreadyArchived && !oneShop) {
            const everyNonCesar = selectedRows.every(
                (el: FidelityRow) => el.fidelityChoiceIndex !== CESAR_LOYALTY
            );
            if (everyNonCesar) {
                ErrorToast(
                    oneShop
                        ? t(
                              "Attention,a shop cannot have more than one fidelity settings"
                          )
                        : t(
                              "Attention, a franchise cannot have more than one setting fidelity"
                          )
                );
            } else {
                setIsModalOpened(!isModalOpened);
                activate();
            }
        } else {
            activate();
        }
    }, [
        selectedRows,
        oneShop,
        isFidelityArchived,
        dataArchive,
        dataActive,
        isModalOpened,
        setIsModalOpened,
        setIsFidelityClicked,
        activate,
        triggerArchiveFlow,
        t,
    ]);
}
